import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Crosshair, Shield } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-stadium-gradient" data-id="element-111">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-112" />

      {/* Crowd Silhouette (Abstract representation using gradients) */}
      <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-dark to-transparent z-10" data-id="element-113" />
      <div className="absolute bottom-0 left-0 w-full h-32 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxmaWx0ZXIgaWQ9Im4iPjxmZVR1cmJ1bGVuY2UgdHlwZT0iZnJhY3RhbE5vaXNlIiBiYXNlRnJlcXVlbmN5PSIwLjgiIG51bU9jdGF2ZXM9IjMiIHN0aXRjaFRpbGVzPSJzdGl0Y2giLz48L2ZpbHRlcj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ0cmFuc3BhcmVudCIvPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNuKSIgb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-30 z-0" data-id="element-114" />

      {/* Spotlights */}
      <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-neon-cyan/20 blur-[120px] pointer-events-none" data-id="element-115" />
      <div className="absolute top-[20%] -right-[10%] w-[40%] h-[40%] rounded-full bg-neon-magenta/20 blur-[120px] pointer-events-none" data-id="element-116" />

      <div className="container mx-auto px-6 relative z-20" data-id="element-117">
        <div className="max-w-4xl mx-auto text-center" data-id="element-118">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-dark-lighter border border-white/10 mb-8" data-id="element-119">
            <span className="w-2 h-2 rounded-full bg-neon-lime animate-pulse" data-id="element-120" />
            <span className="text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-121">
              Platform Beta Live in Europe
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="font-rajdhani text-5xl md:text-7xl lg:text-8xl font-bold leading-tight mb-6" data-id="element-122">
            WHERE ESPORTS TEAMS MEET THEIR{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-magenta text-glow-cyan" data-id="element-123">
              PERFECT SPONSORS
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-124">
            The centralized marketplace connecting rising esports rosters with
            brands seeking authentic gaming audiences. Stop cold-emailing. Start
            closing deals.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-125">
            <button className="w-full sm:w-auto group relative px-8 py-4 bg-neon-cyan text-dark font-bold text-lg rounded-md shadow-[0_0_20px_rgba(0,243,255,0.4)] hover:shadow-[0_0_30px_rgba(0,243,255,0.6)] transition-all flex items-center justify-center gap-2 overflow-hidden" data-id="element-126">
              <Shield className="w-5 h-5" data-id="element-127" />
              Find Sponsors
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-128" />
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-129" />
            </button>

            <button className="w-full sm:w-auto group px-8 py-4 bg-dark-lighter border border-white/20 text-white font-bold text-lg rounded-md hover:border-neon-magenta hover:shadow-[0_0_20px_rgba(255,0,255,0.2)] transition-all flex items-center justify-center gap-2" data-id="element-130">
              <Crosshair className="w-5 h-5 text-neon-magenta" data-id="element-131" />
              Discover Teams
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}